import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ShaftRolesService {

  constructor(private firestore: AngularFirestore) { }

  getShaftRoles() {
    return this.firestore.collection('shaftRoles').snapshotChanges();
  }
}
